import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 6 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 7,
  class: "ion-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.professionExtraInfo && _ctx.professionExtraInfo['Video'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professionExtraInfo['Video'], (info) => {
            return (_openBlock(), _createElementBlock("iframe", {
              class: "responsive-embed",
              key: info.id,
              style: {"width":"100%","height":"250px"},
              src: _ctx.getEmbeddedYTLink(info.content),
              frameborder: "0",
              allowfullscreen: ""
            }, null, 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_accordion_group, {
      value: _ctx.gptExplanationHTML ? 'gptExplanation' : (_ctx.expandAlumniSection ? 'Alumni' : null)
    }, {
      default: _withCtx(() => [
        (_ctx.gptExplanationHTML)
          ? (_openBlock(), _createBlock(_component_ion_accordion, {
              key: 0,
              value: "gptExplanation"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("How it's related to my strength?")
                      ])),
                      _: 1,
                      __: [0]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", {
                              style: {"white-space":"pre-line"},
                              innerHTML: _ctx.gptExplanationHTML
                            }, null, 8, _hoisted_3),
                            _cache[1] || (_cache[1] = _createElementVNode("b", null, [
                              _createElementVNode("small", null, "**This information provided by ChatGPT is for reference purposes only and may not be entirely accurate. It should not be relied upon for any purpose without verification. We are not responsible for any errors or omissions in the information provided.")
                            ], -1))
                          ]),
                          _: 1,
                          __: [1]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.getFilteredAlumniContactRelations().length > 0)
          ? (_openBlock(), _createBlock(_component_ion_accordion, {
              key: 1,
              value: "Alumni"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "primary",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("Alumni")
                      ])),
                      _: 1,
                      __: [2]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredAlumniContactRelations(), (cr) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: cr.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: cr.sourceLink
                              }, _toDisplayString(cr.sourceLink), 9, _hoisted_4)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.professionExtraInfo && _ctx.professionExtraInfo['ChatGPT'])
          ? (_openBlock(), _createBlock(_component_ion_accordion, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Introduction by "),
                        _createElementVNode("b", null, "ChatGPT", -1)
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", {
                              style: {"white-space":"pre-line"},
                              innerHTML: _ctx.professionExtraInfo['ChatGPT'][0]?.content.replace(/.*Yue Cantonese.*\n/g, '').replace('\n\n\n\n', '\n\n').trim()
                            }, null, 8, _hoisted_5),
                            _cache[4] || (_cache[4] = _createElementVNode("b", null, [
                              _createElementVNode("small", null, [
                                _createElementVNode("br"),
                                _createTextVNode("**This information provided by ChatGPT is for reference purposes only and may not be entirely accurate. It should not be relied upon for any purpose without verification. We are not responsible for any errors or omissions in the information provided.")
                              ])
                            ], -1))
                          ]),
                          _: 1,
                          __: [4]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_accordion, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              color: "dark",
              slot: "header"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Search Jobs")
                  ])),
                  _: 1,
                  __: [5]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_list, { slot: "content" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.encodeJobsURI(_ctx.profession, 'google')
                    }, "fr Google Jobs", 8, _hoisted_6)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.encodeJobsURI(_ctx.profession, '51job')
                    }, "fr 51job", 8, _hoisted_7)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.encodeJobsURI(_ctx.profession, 'zhipin')
                    }, "fr BOSS直聘", 8, _hoisted_8)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.professionExtraInfo && _ctx.professionExtraInfo['Job Example'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ion_accordion, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    color: "dark",
                    slot: "header"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Job Example")
                        ])),
                        _: 1,
                        __: [6]
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_list, { slot: "content" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professionExtraInfo['Job Example'], (info_content) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: info_content.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: info_content.content
                            }, _toDisplayString(info_content.name), 9, _hoisted_10)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.relatedSectors && _ctx.relatedSectors.length > 0)
          ? (_openBlock(), _createBlock(_component_ion_accordion, { key: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Related employer sectors")
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedSectors, (sector, idx) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: sector.id,
                        button: "",
                        detail: "",
                        onClick: ($event: any) => (_ctx.openSectorModal(sector.id, ''))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(idx+1) + ". " + _toDisplayString(sector.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ion_accordion, { key: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("Employed in")
                      ])),
                      _: 1,
                      __: [8]
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profession.relatedSegments, (segment) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: segment.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.openSectorModal(segment.sector.id, segment.id))
                                }, _toDisplayString(segment.name), 9, _hoisted_11),
                                _cache[9] || (_cache[9] = _createTextVNode(" -"))
                              ]),
                              _createElementVNode("p", null, [
                                _cache[10] || (_cache[10] = _createTextVNode("segment of the ")),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.openSectorModal(segment.sector.id, ''))
                                }, _toDisplayString(segment.sector.name), 9, _hoisted_12),
                                _cache[11] || (_cache[11] = _createTextVNode(" sector"))
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        (_ctx.professionExtraInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professionExtraInfo, (info, group) => {
                return _withDirectives((_openBlock(), _createBlock(_component_ion_accordion, { key: group }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      color: "dark",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(group), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_list, { slot: "content" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (info_content) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: info_content.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: info_content.content
                              }, _toDisplayString(group.toString() == 'LinkedIn Alumni' ? info_content.content.replace("https://", "") : info_content.name), 9, _hoisted_14)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)), [
                  [_vShow, !['Job Example', 'Salary', 'Awards', 'ChatGPT'].includes(group)]
                ])
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_accordion, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              color: "light",
              slot: "header"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("More")
                  ])),
                  _: 1,
                  __: [12]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_list, {
              class: "ion-no-padding",
              slot: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion_group, null, {
                  default: _withCtx(() => [
                    (_ctx.professionExtraInfo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreProfessionExtraInfo(_ctx.profession), (info, key) => {
                            return (_openBlock(), _createBlock(_component_ion_accordion, { key: key }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  color: "dark",
                                  slot: "header"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(key), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_list, { slot: "content" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (info_content) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        key: info_content.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            target: "_blank",
                                            href: info_content.content
                                          }, _toDisplayString(info_content.name), 9, _hoisted_16)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_accordion, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          color: "dark",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("Jobs with these entry qualification found")
                              ])),
                              _: 1,
                              __: [13]
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_list, { slot: "content" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  checked: _ctx.profession.requiresSecondarySchool,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode("Secondary School")
                                  ])),
                                  _: 1,
                                  __: [14]
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  checked: _ctx.profession.requiresHigherDiplomaAndAssociate,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createTextVNode(" Higher Diploma and Associate ")
                                  ])),
                                  _: 1,
                                  __: [15]
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  checked: _ctx.profession.requiresBachelor,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode(" Bachelor ")
                                  ])),
                                  _: 1,
                                  __: [16]
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  checked: _ctx.profession.requiresMaster,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createTextVNode(" Master ")
                                  ])),
                                  _: 1,
                                  __: [17]
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  justify: "start",
                                  labelPlacement: "end",
                                  checked: _ctx.profession.requiresDoctorate,
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode(" Doctorate ")
                                  ])),
                                  _: 1,
                                  __: [18]
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cvcl, (info, key) => {
                      return (_openBlock(), _createBlock(_component_ion_accordion, { key: key }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            color: "dark",
                            slot: "header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(key == 'curriculum_vitae' ? "CV examples" : (key == 'cover_letter' ? "Sample claims" : key)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_list, { slot: "content" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", { innerHTML: info }, null, 8, _hoisted_17)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.loadingExtraInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_ion_spinner)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}